import {
  GCRContentConnectionManagementClient,
  ListCollectionsCommand,
  ListUseCasesCommand,
  GetCollectionDetailCommand,
  GetUseCaseDetailCommand,
  CreateCollectionCommand,
  UpdateCollectionCommand,
  CreateSubscriptionCommand,
  CancelSubscriptionCommand,
  type Collection,
  type UseCase,
  type GetCollectionDetailInput,
  type GetUseCaseDetailInput,
  type CreateCollectionInput,
  type UpdateCollectionInput,
  type CreateSubscriptionInput,
  type CreateSubscriptionOutput,
  type CancelSubscriptionInput,
  type CancelSubscriptionOutput,
} from '@amzn/aws-gcr-content-connection-management-client';
import { getConnectionManagementEndpoint } from '../utils/endpointUtil';
import type { Region } from '../shared/contexts/RegionContext';

class ConnectionManagementService {
  private client: GCRContentConnectionManagementClient;
  private currentRegion: Region = 'global';

  constructor() {
    this.client = new GCRContentConnectionManagementClient({
      region: 'us-east-1',
      endpoint: getConnectionManagementEndpoint(this.currentRegion),
    });
  }

  setRegion(region: Region) {
    this.currentRegion = region;
    this.client = new GCRContentConnectionManagementClient({
      region: region === 'china' ? 'cn-northwest-1' : 'us-east-1',
      endpoint: getConnectionManagementEndpoint(region),
    });
  }

  async listCollections(): Promise<Collection[]> {
    const command = new ListCollectionsCommand({});
    const response = await this.client.send(command);
    return response.collections || [];
  }

  async getCollectionDetail(input: GetCollectionDetailInput): Promise<Collection> {
    const command = new GetCollectionDetailCommand(input);
    const response = await this.client.send(command);
    return response;
  }

  async listUseCases(): Promise<UseCase[]> {
    const command = new ListUseCasesCommand({});
    const response = await this.client.send(command);
    return response.useCases || [];
  }

  async getUseCaseDetail(input: GetUseCaseDetailInput): Promise<UseCase> {
    const command = new GetUseCaseDetailCommand(input);
    const response = await this.client.send(command);
    return response;
  }

  async createCollection(input: CreateCollectionInput): Promise<Collection> {
    const command = new CreateCollectionCommand(input);
    const response = await this.client.send(command);
    return response;
  }

  async updateCollection(input: UpdateCollectionInput): Promise<Collection> {
    const command = new UpdateCollectionCommand(input);
    const response = await this.client.send(command);
    return response;
  }

  async createSubscription(input: CreateSubscriptionInput): Promise<CreateSubscriptionOutput> {
    const command = new CreateSubscriptionCommand(input);
    const response = await this.client.send(command);
    return response;
  }

  async cancelSubscription(input: CancelSubscriptionInput): Promise<CancelSubscriptionOutput> {
    const command = new CancelSubscriptionCommand(input);
    const response = await this.client.send(command);
    return response;
  }
}

export const connectionManagementService = new ConnectionManagementService();
